<template>
    <Dialog
        :action-items="actionItems"
        :show.sync="isShown"
        title="Установить приложение?"
    >
        Чтобы устаноновить приложение, просто нажмите
        <v-img src="img/ios-options.png" width="16" style="margin: 0 4px;"/>
        затем нажмите "На экран «Домой»"
    </Dialog>
</template>

<script>
    import Dialog from '@/components/Vuetify/Dialog'

    export default {
        name: 'InstallAppleDialog',

        components: { Dialog },

        props: {
            show: { type: Boolean },
        },

        computed: {
            isShown: {
                get() {
                    return this.show
                },
                set(isShown) {
                    this.$emit('update:show', isShown)
                },
            },

            actionItems() {
                return [
                    {
                        text: 'Закрыть',
                        click: () => this.closeDialog(),
                    },
                ]
            },
        },

        methods: {
            closeDialog() {
                this.isShown = false
            },
        },
    }
</script>
